<template>
<div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {

      };
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="less">
  // body{
  //   min-width: 1200px;
  // }

</style>
